<template>
    <v-app style="background-color:#eeeeee">
      <!-- <div style="margin-top:0px;background-color:#F8F8F8">
           <p style="text-align:center;padding-top:15px">
              <span @click="home()" class="hvr txt">Home</span> / <span style="color:#EA0202" class="txt">Blogs</span></p>
       </div> -->
       <div class="kolkata5 res">
           <v-layout row wrap class="">
              <v-flex xs12 sm12 md6 lg12 style="text-align:center">
                   <h1 style="padding:25px;color:whitesmoke;">Gallery Photos</h1>
              </v-flex>
           </v-layout>
       </div>
        <div class="kolkata5 man">
            <v-layout row wrap class="container" style="margin-top:50px">
                <v-flex xs12 sm12 md6 lg12 >
                    <h1 style="padding:15px;color:whitesmoke;">Gallery Photos</h1>
                </v-flex>
            </v-layout>
        </div>
       
       <div class="container">
  
        <v-layout row wrap>
    <v-flex xs12 sm12 md3 v-for="item in blogs" :key="item.id">
      <v-card class="mx-auto">
          <v-img
          :src=item.src         
           height="200px"
            cover
          ></v-img>
        </v-card>
    </v-flex>
  </v-layout>
  
  
         <h1 style="text-align:center;padding-top:25px;" v-if="blogs.length==0">
           Gallery will be uploaded soon !</h1>
       </div>
        
      <v-dialog width="150px" v-model="loading" persistent>
        <v-card style="padding:15px">
          <h6 style="text-align:center">Please wait...</h6>
        </v-card>
      </v-dialog>
       
    </v-app>
  </template>
  
  <script>
  import config from "./../../config.json";
  //import carousel from 'vue-owl-carousel';
  //import VueEasyLightbox from 'vue-easy-lightbox';
  //import GoTop from '@inotom/vue-go-top';
  
  export default {
    components: {
    },
    data() {
      return {
        valid: true,
        loading: false,
        isLoading: false,
        search: null,
        model: null,
  
        itemAdded: [
          {
            id: 0,
            name: "Home"
          }
        ],
  
        form: {
          tourPackage: null,
          destination: null
        },
  
        categories1: [],
        subCategories: [],
  
        id: 0,
        itemList: null,
  
        items: [],
        items1: [],
  
        selectionType: null,
        blogs: [],
      };
      
    },
    
     mounted() {
       this.axios
          .get(config.API + "gallery/authors", {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(res => {
            let list = res.data.authors;
  
            for (let index = 0; index < list.length; index++) {
              const element = list[index];
              
              this.blogs.push({
                id: element.id,
                src: config.API1 + "gallery/files/" + element.src
              })
            }
  
            console.log(this.blogs);
          })
          .catch(() => {
            this.$Progress.fail();
          });
       
     },
  
   methods: {
     blg(item) {
      console.log(item);
       sessionStorage.setItem("blogTitle", item.title);
       sessionStorage.setItem("blogDescription", item.description);
       sessionStorage.setItem("blogSrc", item.src);
       this.$router.push("/blogDetail/" + item.id );
     },
   }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
  </style>
  
  <style scoped>
  .banner {
    background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
    background-size: cover;
    height:200px;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
  .kolkata5 {
      background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('http://www.royalacpaints.com/images/about-us-banner.jpg');
      background-size: cover;
  }
  
  .hvr:hover {
    cursor: pointer;
    /* height: 200px; */
    border : 2px solid;
    border-color: black !important;
  }
  .hvr1:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #2196f3;
  }
  .v-card {
    padding: 10px;
    border-radius: 8px;
  }
  .v-sheet--offsets {
    top: -50px;
    position: relative;
  }
  .v-sheet--offset {
    top: -30px;
    position: relative;
  }
  .v-sheet--offsetf {
    top: -100px;
    position: relative;
  }
  .swo {
    box-shadow: none !important;
  }
  .opa {
    opacity: 1;
  }
  .tourtheme {
    height: 180px;
    margin: 5px;
    background-size: cover;
  }
  .themecap {
    font-family: 'Open Sans', sans-serif;
    padding-top: 130px;
    color: white;
  }
  .top-left {
    font-family: 'Roboto Mono', monospace;
    font-size:40px ;
    padding-top: 200px;
    color: white;
    text-align: center;
  }
  .salont {
    font-family: 'Patua One', cursive;
  }
  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .hvr:hover {
    cursor: pointer;
    border-radius: 5px !important;
    border : 1px solid;
    border-color: black !important;
    transition-duration: 0.7s;
    text-decoration: none !important;
  }
  .v-table tbody tr:not(:last-child) {
      border-bottom: none !important;
  }
  @media screen and (max-width: 768px) {
    .res {
      display: none;
    }
  }
  @media screen and (min-width: 768px){
    .man {
      display: none;
    }
  }
  img.center {
      display: block;
      margin: 0 auto;
  }
  .recent {
    font-family: 'Nanum Gothic', sans-serif;
  }
  .srch {
    position: absolute;
    z-index: 10;
    left: 16%;
    top: 0%;
  }
  .item {
      border:1px solid !important;
  }
  </style>
  